import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { BaseParams } from 'types/utils'

export function useRemoveRoommate() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError() // Added usage
  const { t } = useTranslation('application')

  async function removeRoommate({ id }: BaseParams<{}, 'DELETE'>) {
    const res = await apiClient.delete<undefined>(
      SNA_PREFIX + `invitations/${id}/`
    )
    return res.data
  }

  return useMutation({
    mutationFn: removeRoommate,
    onSuccess: () => {
      toast.success({ message: t('toast.roommateRemoved') })
      queryClient.invalidateQueries({ queryKey: ['applications'] })
    },
    onError // Replaced inline function
  })
}
